import { render, staticRenderFns } from "./ParticipacoesAtividades.vue?vue&type=template&id=841a43d4"
import script from "./ParticipacoesAtividades.vue?vue&type=script&lang=js"
export * from "./ParticipacoesAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports